import { MODULES } from "../../../../utils/constants";
import { routes } from "../../../../constants/routes";
import icons from "../../../../assets/icons/valid-icons";
import InfoIcon from "../../../../assets/icons/terms-info-icon.svg";

export interface MenuItem {
  label: string;
  icon?: string;
  path: string;
  subMenu?: MenuItem[];
  classNames: string;
  isOpen?: boolean;
  disabled?: boolean;
  moduleName?: string;
  isModuleEnabled?: boolean;
  permissionRole?: any[];
  onlyShowTOAFP?: boolean;
  navbarItem?: boolean;
}

export interface SidebarProps {
  menuItems: MenuItem[];
  footerItems: MenuItem[];
}

export const menuItems: MenuItem[] = [
  {
    label: "Dashboard",
    icon: icons.DashboardIcon,
    path: routes.PROVIDER_DASHBOARD,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Profile Management",
    icon: icons.ProfileManagementIcon,
    path: routes.PROVIDER_PROFILE_MGMT,
    classNames: "",
    navbarItem: false,
    // subMenu: [
    //   {
    //     label: "Provider Profile",
    //     icon: "",
    //     path: routes.PROVIDER_PROFILES,
    //     moduleName: MODULES.PROVIDER_PROFILES,
    //     classNames: "",
    //   },
    //   {
    //     label: "Provider Requests",
    //     icon: "",
    //     path: routes.PROVIDER_REQUESTS,
    //     moduleName: MODULES.PROVIDER_REQUESTS,
    //     classNames: "",
    //   }
    // ]
  },
  {
    label: "Service Management",
    icon: icons.ProviderServiceManagementIcon,
    path: routes.PROVIDER_SERVICE_LIST,
    classNames: "",
    navbarItem: false,
    // subMenu: [
    //   {
    //     label: "Service List",
    //     icon: "",
    //     path: routes.SERVICE_LIST,
    //     moduleName: MODULES.SERVICE_LIST,
    //     classNames: "",
    //   }
    // ]
  },
  {
    label: "Contract Orders",
    icon: icons.BookingAppointmentIcon,
    path: routes.BOOKING_AND_APPOINTMENT,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Leads",
    icon: icons.LeadsIcon,
    path: routes.PROVIDER_LEADS,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Payments & Billing",
    icon: icons.PaymentBillingIcon,
    path: routes.PAYMENTS_AND_BILLING,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Contract Templates",
    icon: icons.ContractManagement,
    path: routes.PROVIDER_CONTRACT_MANAGEMENT,
    classNames: "",
    navbarItem: false,
  },

  {
    label: "AFP Tech Support",
    icon: icons.CommunicationIcon,
    path: routes.PROVIDER_COMMUNICATION,
    classNames: "",
    navbarItem: false,
  },
];

export const footerItems: MenuItem[] = [
  {
    label: "Terms of Service",
    icon: InfoIcon,
    path: routes.PROVIDER_TERMS_OF_SERVICE,
    classNames: "",
    navbarItem: false,
  },
];
